import { Star as StarIcon } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { ICONS } from "../../data/defaults";

export const WhyChooseUs = () => {
  const { whyUs } = useContent();
  return (
    <section id="why-us" className="relative overflow-hidden bg-navy py-24" data-testid="why-us-section">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(217,164,65,0.12),transparent_50%)]" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading light eyebrow={whyUs.eyebrow} title={whyUs.title} desc={whyUs.desc} />
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {whyUs.items.map((f, i) => {
            const Icon = ICONS[f.icon] || StarIcon;
            return (
              <Reveal key={f.title} delay={i * 0.07}>
                <div
                  data-testid={`why-card-${i}`}
                  className="group h-full rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur transition-all hover:-translate-y-1 hover:border-gold/40 hover:bg-white/[0.07]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold text-navy">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-bold text-white">{f.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/60">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
